/**
 * 前端多语言解决方案
 */
import _ from 'underscore';
import url from 'c-url';
import enusLangPack from './enus';

let _lang = {
    
   
    template: function(tplStr, data, insertEM){

        let lang = UP.Global.siteLanguage;
        let langType = lang.replace('-', '').toLowerCase();
        let langPack = window.LangPack || enusLangPack;
        
        let tpl = (langPack[tplStr] || tplStr)+'';

        try{
            if (tpl) {
                if (tpl.indexOf('@@@@') > 0) {
                    let strArr = [];
                    
                    strArr.push('<ul>');
                    tpl.split('@@@@').forEach(function(item, index){
                        item && strArr.push('<li>' + item + '</li>');
                    }); 
                    strArr.push('</ul>');
                    tpl = strArr.join('');   
                }
                if (insertEM) {
                    tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function($0, $1){
                        return '<em class="' + $1 +'">' + $0+ '</em>';
                    });     
                }

                let compiled = _.template(tpl);
                return compiled(data);

            } else {
                return _.template(tplStr)(data);
            }
        }catch(e){
            console.log(e.message);
        }
    }
};

module.exports = _lang;



// WEBPACK FOOTER //
// ./js/lang/index.js